import React, { useContext } from 'react';
import { Button, Chip, Divider, Stack, Typography, useMediaQuery } from '@mui/material';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import * as R from 'ramda';
import { CreateReconsignmentContext } from '../Create';

const Header = () => {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });
  const title = lgUp ? 'Source Locations' : 'Locations';
  const { info, setIsDrawerOpen } = useContext(CreateReconsignmentContext);
  // check if is recurring
  const isRecurring = R.prop('isRecurring', info);
  const destinationsLength = R.length(R.prop('destinations', info));

  return (
    <Stack
      sx={{
        backgroundColor: 'surface.light',
        justifyContent: 'space-between',
        pb: 2,
        position: 'sticky',
        pt: 3,
        px: 2,
        top: 48,
        zIndex: 1,
      }}
    >
      <Button
        onClick={() => setIsDrawerOpen(true)}
        sx={theme => ({
          ...theme.typography.button,
          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          display: { xs: 'inline-flex', lg: 'none' },
          justifyContent: 'flex-start',
          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          mb: { xs: 0, sm: 0.5 },
          ml: -1,
          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          mr: { xs: 0, sm: 3 },
          mt: 0,
          pl: 0,
        })}
        variant="text"
      >
        <ChevronLeftRoundedIcon sx={{ mt: '-2px' }} />
        Parameters
      </Button>
      <Stack alignItems="center" direction="row" spacing={1}>
        <Typography data-testid="title" variant="h5">
          {title}
        </Typography>
        <Chip label={R.length(R.prop('sourceLocations', info))} type="accordion" variant="badge" />
      </Stack>
      <Typography data-testid="subTitle" sx={{ mb: 1, mt: 2 }} variant="caption">
        {isRecurring &&
          'Select your desired Source Location. Reoccurring reconsignments can only have 1 Destination and 1 Source Location'}
        {destinationsLength > 1 &&
          'Select your desired Source Location. If you have more than 1 Destination, then only the 1 Source Location can be selected.'}
        {destinationsLength === 1 &&
          'Select your desired Source Locations. If you have 1 Destination, then more than 1 Source Location can be selected.'}
      </Typography>
      <Divider />
    </Stack>
  );
};

export default Header;
